import React, {useState} from "react"
import {InviteFFPopupForm} from "./Form"
import {InviteFFPopupSuccess} from "./Success"
import {User} from "@irati/types"
import {useFriendsAndFamily} from "@irati/identity/hooks"

interface FamilyFriendsPopupProps {
  showPopup: boolean
  onHide: () => void
}

enum Steps {
  FORM,
  SUCCESS
}
export const FamilyFriendsPopup: React.FC<FamilyFriendsPopupProps> = ({showPopup, onHide}) => {
  const [step, setStep] = useState<Steps>(Steps.FORM)
  const friendsAndFamily = useFriendsAndFamily()
  const [inviteData, setInviteData] = useState<User | null>(null)
  const onSuccess = (user: User) => {
    setInviteData(user)
    setStep(Steps.SUCCESS)
  }

  const handleClose = () => {
    setStep(Steps.FORM)
    onHide()
  }

  const handleBackToForm = () => {
    setStep(Steps.FORM)
    setInviteData(null)
  }

  if (!showPopup || friendsAndFamily.isOFF) {
    return null
  }

  return (
    <>
      {step === Steps.FORM && <InviteFFPopupForm onSuccess={onSuccess} onHide={handleClose} />}
      {step === Steps.SUCCESS && inviteData && (
        <InviteFFPopupSuccess user={inviteData} onHide={handleClose} onNewInvitation={handleBackToForm} />
      )}
    </>
  )
}
